import WithUserTimeHOC, { WithUserTimeProps } from '@hocs/WithUserTime'
import { GroupNote } from '@interfaces/MySchedule'
import { GET_LESSON_GROUP_DETAIL } from '@queries/index'
import get from 'lodash/get'
import map from 'lodash/map'
import React from 'react'
import { withApollo, WithApolloClient } from 'react-apollo'

interface QueryPageResults {
  loading: boolean
  error: boolean
  refetch: Function
  GroupNotes: GroupNote[]
}

interface QueryPageDataProp {
  GroupNotes: GroupNote[] | undefined
  data: any
  InstructorId: string
  StartDateTime: string
  EndDateTime: string
  Language: string
  ProgramId: string
  children: (results: QueryPageResults) => {}
}

export type Props = WithApolloClient<QueryPageDataProp & WithUserTimeProps>

class QueryNotesData extends React.Component<Props> {
  _isMounted = false
  abortCtrl = new AbortController()

  state = {
    loading: false,
    error: false,
    GroupNotes: [] as GroupNote[],
  }

  async componentDidMount() {
    this._isMounted = true
    this.fetchData()
  }

  componentWillUnmount() {
    this._isMounted = false
    this.abortCtrl.abort()
  }

  fetchData = async () => {
    const { data } = this.props

    try {
      this.setState({
        loading: true,
        error: false,
      })

      const promisedGroupNotes = map(this.props.GroupNotes, async (note, index) => {
        if (index === 0) {
          return {
            ...note,
            Notes: data.Notes,
          }
        }

        const detail = await this.getGroupDetail(note.SessionIds)
        const gc = this.concatUsersNote(detail.GroupClassList)

        return {
          ...note,
          Notes: gc[0].Notes,
        }
      })
      const GroupNotes = await Promise.all(promisedGroupNotes)

      if (this._isMounted) {
        this.setState({
          loading: false,
          GroupNotes,
        })
      }
    } catch (error) {
      if (this._isMounted) {
        this.setState({
          loading: false,
          error: true,
        })
      }
    }
  }

  getGroupDetail = async (sessionIds = [] as string[]) => {
    const { client, InstructorId, StartDateTime, EndDateTime, ProgramId, Language = '' } = this.props
    const SessionIds = sessionIds.join(',')

    const params = {
      InstructorId,
      StartDateTime,
      EndDateTime,
      FILTER_TYPE: 'Details',
      ProgramId,
      SessionIds,
      Language,
    }

    const res = await client.query({
      query: GET_LESSON_GROUP_DETAIL,
      variables: { params },
      fetchPolicy: 'network-only',
    })

    return get(res.data, 'getLessonGroups.0.InstructorGroupInfo', {})
  }

  concatUsersNote = groups =>
    map(groups, group => {
      const notes = map(group.StudentNotes, (note, index: number) => ({
        Id: index + 1,
        Name: note.StudentName,
        Role: 'Student',
        Message: note.Note,
        BackgroundColor: 'red100',
        ForegroundColor: 'white',
      }))

      const instructor = {
        Id: notes.length + 1,
        Name: group.InstructorNote.InstructorName,
        Role: 'Instructor',
        Message: group.InstructorNote.Note,
        BackgroundColor: 'purple100',
        ForegroundColor: 'white',
      }

      notes.push(instructor)

      group.Notes = notes
      return group
    })

  render() {
    const { children } = this.props
    const { loading, error, GroupNotes } = this.state

    return children({
      loading,
      error,
      GroupNotes,
      refetch: this.fetchData,
    })
  }
}

export default WithUserTimeHOC(withApollo(QueryNotesData))
